import { NgModule } from '@angular/core';
import { TooltipDirective } from './tooltip.directive';
import { ScrollbarDirective } from './scrollbar-directive';
import { KeyboardCloseIconDirective } from './keyboard-close-icon.directive';
import { KeyboardFocusVisibleDirective } from './keyboard-focus-visible.directive';
import { CaretAtEndDirective } from './caret-at-end.directive';
import { FormlyCaretAtEndDirective } from './formly-caret-at-end.directive';
import { AccessibleToggleDirective } from './accessible-toggle.directive';
import { NoWhitespaceOnlyValidatorDirective } from './no-whitespace-only-validator.directive';
@NgModule({
  declarations: [
    TooltipDirective,
    ScrollbarDirective,
    KeyboardCloseIconDirective,
    KeyboardFocusVisibleDirective,
    CaretAtEndDirective,
    FormlyCaretAtEndDirective,
    AccessibleToggleDirective,
    NoWhitespaceOnlyValidatorDirective
  ],
  imports: [],
  exports: [
    TooltipDirective,
    ScrollbarDirective,
    KeyboardCloseIconDirective,
    KeyboardFocusVisibleDirective,
    CaretAtEndDirective,
    FormlyCaretAtEndDirective,
    AccessibleToggleDirective,
    NoWhitespaceOnlyValidatorDirective
  ],
})
export class DirectivesModule {}
